import React, { useState, useEffect } from 'react';
import { Button } from '@decisiv/ui-components';
import AdminPanel from './AdminPanel';

const csrfToken = () =>
  document.querySelector('[name="csrf-token"]')?.getAttribute('content') ?? '';

const tableStyle  = { width: '100%', borderCollapse: 'collapse', fontSize: 13 };
const thStyle     = { textAlign: 'left', padding: '8px 12px', fontWeight: 600, borderBottom: '2px solid #e0e0e0', color: '#555' };
const tdStyle     = { padding: '8px 12px', borderBottom: '1px solid #f0f0f0', verticalAlign: 'middle' };
const emptyStyle  = { ...tdStyle, textAlign: 'center', color: '#888' };

const SubscriptionPanel = ({ panelConfig, record }) => {
  const [events, setEvents]           = useState([]);
  const [subscribedIds, setSubscribedIds] = useState(record.subscribed_event_ids ?? []);
  const [loading, setLoading]         = useState(true);
  const [loadError, setLoadError]     = useState(false);
  const [toggling, setToggling]       = useState(null);

  useEffect(() => {
    window.fetch(`${panelConfig.eventsEndpoint}?page=1`, {
      headers: { Accept: 'application/json' },
    })
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then((data) => { setEvents(data.records ?? []); })
      .catch(() => setLoadError(true))
      .finally(() => setLoading(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = async (event) => {
    const subscribed = subscribedIds.includes(event.id);
    const url        = subscribed
      ? panelConfig.unsubscribeEndpoint(record)
      : panelConfig.subscribeEndpoint(record);

    setToggling(event.id);
    try {
      const res = await window.fetch(`${url}?event_id=${event.id}`, {
        method:  'POST',
        headers: { 'X-CSRF-Token': csrfToken(), 'Content-Type': 'application/json' },
      });
      if (res.ok) {
        setSubscribedIds((prev) =>
          subscribed ? prev.filter((id) => id !== event.id) : [...prev, event.id]
        );
      }
    } finally {
      setToggling(null);
    }
  };

  return (
    <AdminPanel title={panelConfig.title ?? 'Events'}>
      {loading ? (
        <div style={{ padding: 8, color: '#888' }}>Loading…</div>
      ) : loadError ? (
        <div style={{ padding: 8, color: '#c0392b', fontSize: 13 }}>
          Failed to load events — please refresh the page.
        </div>
      ) : (
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Description</th>
              <th style={{ ...thStyle, width: 140 }}>Subscription</th>
            </tr>
          </thead>
          <tbody>
            {events.length === 0 ? (
              <tr><td colSpan={3} style={emptyStyle}>No events found.</td></tr>
            ) : events.map((event) => {
              const subscribed = subscribedIds.includes(event.id);
              return (
                <tr key={event.id}>
                  <td style={tdStyle}>{event.name}</td>
                  <td style={tdStyle}>{event.description}</td>
                  <td style={tdStyle}>
                    <Button
                      text={subscribed ? 'Unsubscribe' : 'Subscribe'}
                      kind="secondary"
                      intent={subscribed ? 'danger' : undefined}
                      size="small"
                      disabled={toggling === event.id}
                      onClick={() => toggle(event)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </AdminPanel>
  );
};

export default SubscriptionPanel;
